import { render, staticRenderFns } from "./ValidationRequestFilters.vue?vue&type=template&id=15d55a5b"
import script from "./ValidationRequestFilters.vue?vue&type=script&lang=js"
export * from "./ValidationRequestFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports